/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

import DeleteModal from '../../modals/deleteModal'
import EditModal from '../../modals/editModal'
import EditBranchModal from './editBranchModal'
import { branchConstants} from './branchConstants'

function BranchActionButton(props) {
    const [categoryId, setCategoryId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    const [editModal, setEditModal] = useState(false)

    let handleDelete = () => {
        props.data.deleteBranch(props.data.branchId)
    }

    let handleOpenEdit = (e) => {
        setEditModal(true)
    }

    let handleCloseEdit = (e) => {
        setEditModal(false)
    }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        setCategoryId(mainData.id)
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }


    return (
        <>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} /> 
            <EditModal size="large" open={editModal} onClose={handleCloseEdit}>
                <Modal.Header>{branchConstants.edit_title}</Modal.Header>
                <EditBranchModal branch={props.data} agGridProps={props.agGridReact.props} handleCloseEdit={handleCloseEdit} updateBranch={props.data.updateBranch} branchConstants={branchConstants} />
            </EditModal>
        </>

    )
}

export default BranchActionButton
